import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IServiceAgreement } from "./service-agreements.interface";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class ServiceAgreementHttpService {

  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) { }


  getAgreements(filter?: IFilter): Observable<IServiceAgreement[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_SERVICEAGREEMENTS)}${queryParams}`);
  }

  getAgreement(agreement: IServiceAgreement | string): Observable<IServiceAgreement> {
    let id = (typeof agreement == 'string') ? agreement : agreement._id;
    return this._http.get(`${apiURL(EnvConfig.API_SERVICEAGREEMENTS)}/${id}`);
  }

  createAgreement(agreement: IServiceAgreement): Observable<IServiceAgreement> {
    return this._http.post(`${apiURL(EnvConfig.API_SERVICEAGREEMENTS)}`, agreement);
  }
}